// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__aOmNj","componentContainer":"App_componentContainer__2JC2W","centeredComponent":"App_centeredComponent__tXJuB","logo":"App_logo__2loz0"};